import { render, staticRenderFns } from "./CustomerNotePopup.vue?vue&type=template&id=4623633e&scoped=true&"
import script from "./CustomerNotePopup.vue?vue&type=script&lang=js&"
export * from "./CustomerNotePopup.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNotePopup.vue?vue&type=style&index=0&id=4623633e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4623633e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/CustomerNotePopup.vue
// module id = null
// module chunks = 